import { render, staticRenderFns } from "./ActivatePromocode.vue?vue&type=template&id=b590500e&"
import script from "./ActivatePromocode.vue?vue&type=script&lang=js&"
export * from "./ActivatePromocode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports